export default __webpack_public_path__ + "static/media/satish.f2409aac.png";